export var isHexColor = function (colorString) {
    var hexColorRegex = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;
    return hexColorRegex.test(colorString);
};
export var getHex = function (color) {
    if (color.includes('#'))
        return color;
    if (color.includes('x')) {
        var _a = color.split('x'), hex = _a[1];
        return "#".concat(hex);
    }
    return undefined;
};
export var rgbToHex = function (rgb) {
    var match = rgb.match(/^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/);
    if (!match) {
        return null;
    }
    var r = parseInt(match[1], 10);
    var g = parseInt(match[2], 10);
    var b = parseInt(match[3], 10);
    if (r < 0 || r > 255 || g < 0 || g > 255 || b < 0 || b > 255) {
        return null;
    }
    var toHex = function (c) {
        var hex = c.toString(16);
        return hex.length === 1 ? "0".concat(hex) : hex;
    };
    return "#".concat(toHex(r)).concat(toHex(g)).concat(toHex(b));
};
export var hexToRgb = function (hex) {
    var cleanHex = hex.charAt(0) === '#' ? hex.substring(1, 7) : hex;
    var r = parseInt(cleanHex.substring(0, 2), 16);
    var g = parseInt(cleanHex.substring(2, 4), 16);
    var b = parseInt(cleanHex.substring(4, 6), 16);
    return { r: r, g: g, b: b };
};
var getLuminance = function (r, g, b) {
    var a = [r, g, b].map(function (v) {
        var s = v / 255;
        return s <= 0.03928 ? s / 12.92 : Math.pow(((s + 0.055) / 1.055), 2.4);
    });
    return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
};
export var getContrastColor = function (color) {
    if (typeof color === 'string') {
        var _a = hexToRgb(color), r = _a.r, g = _a.g, b = _a.b;
        var luminance = getLuminance(r, g, b);
        return luminance > 0.179 ? '#000000' : '#ffffff';
    }
    return '#000000';
};
export var hexToHsv = function (hex) {
    var cleanHex = hex.replace(/^#/, '');
    var r = 0;
    var g = 0;
    var b = 0;
    if (cleanHex.length === 3) {
        r = parseInt(cleanHex[0] + cleanHex[0], 16);
        g = parseInt(cleanHex[1] + cleanHex[1], 16);
        b = parseInt(cleanHex[2] + cleanHex[2], 16);
    }
    else if (cleanHex.length === 6) {
        r = parseInt(cleanHex.slice(0, 2), 16);
        g = parseInt(cleanHex.slice(2, 4), 16);
        b = parseInt(cleanHex.slice(4, 6), 16);
    }
    else {
        throw new Error('Invalid HEX color format');
    }
    r /= 255;
    g /= 255;
    b /= 255;
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var delta = max - min;
    var h = 0;
    var s = 0;
    var v = max;
    if (delta !== 0) {
        if (max === r) {
            h = 60 * (((g - b) / delta) % 6);
        }
        else if (max === g) {
            h = 60 * ((b - r) / delta + 2);
        }
        else {
            h = 60 * ((r - g) / delta + 4);
        }
        if (max !== 0) {
            s = delta / max;
        }
    }
    if (h < 0)
        h += 360;
    return { h: h, s: s, v: v };
};
export var hexToHsl = function (hex) {
    var _a = hexToRgb(hex), r = _a.r, g = _a.g, b = _a.b;
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var delta = max - min;
    var h = 0;
    var s = 0;
    var l = (max + min) / 2;
    if (delta !== 0) {
        if (max === r) {
            h = (g - b) / delta + (g < b ? 6 : 0);
        }
        else if (max === g) {
            h = (b - r) / delta + 2;
        }
        else {
            h = (r - g) / delta + 4;
        }
        h /= 6;
        s = l === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    }
    return {
        h: Math.round(h * 360),
        s: Math.round(s * 100) / 100,
        l: Math.round(l * 100) / 100,
    };
};
